import BlankButton from '@xo-union/component-blank-button';
import { H4 } from '@xo-union/tk-ui-typography';
import React from 'react';

import { messagingHubRoute } from '../../helpers/routes';
import { ButtonDropdownItem } from '../ButtonDropdown';
import useShareTracking from '../SharePage/useShareTracking';
import { Copy, copy } from './SequencePreview';
import { Props } from './SidebarCell';
import styles from './sidebarCell.scss';

const MobileSidebarCell: React.FC<Props> = ({ sequence, selectedSequence, websiteState, onClick }) => {
  const isActive = sequence.sequenceType === selectedSequence?.sequenceType;
  const track = useShareTracking();
  const hideSequence =
    websiteState === 'uninitialized' &&
    (sequence.displayName === 'Share your website' || sequence.displayName === 'Remind guests to RSVP');

  if (hideSequence) return null;

  return (
    <BlankButton onClick={() => onClick(sequence)} className={`${styles.mobileCell} ${isActive ? styles.active : ''}`}>
      <H4>{sequence.displayName}</H4>
      {isActive &&
        selectedSequence?.supportedTypes.map(s => {
          const to = `${messagingHubRoute}/${selectedSequence.sequenceType}-${s.type.toLowerCase()}/${s.id}/edit`;

          // Hiding SMS for livestream
          if (selectedSequence.displayName === 'Livestream Info' && s.type === 'sms') {
            return null;
          }

          return (
            <ButtonDropdownItem
              key={`${s.id}-${s.type}`}
              to={to}
              onClick={() => {
                track('Website Share Initiated', {
                  page: 'messaging hub',
                  action: 'select template',
                  messageMedium: s.type,
                  messageType: selectedSequence.displayName,
                });
              }}
              data-testid={`component-${s.type}-button`}
              {...copy[s.type as keyof Copy]}
            />
          );
        })}
    </BlankButton>
  );
};

export default MobileSidebarCell;
